module.exports = __webpack_public_path__ + "img/cx_teste_covid_antigeno.53c82e14.webp";